import { useEffect } from 'react';
import {
  useSendDataDogCustomEvent,
  UseSendDataDogCustomResult
} from '../../shared/hooks/useSendDataDogCustomEvent';
import { removeLocalStorageItem, setLocalStorageItem } from '../localStorage';

export const AG_TRACKING_KEY = 'ag-tracking';
export const AG_REFERRER_KEY = 'ag-referrer';
export const AG_TRACKING_PARAMS_KEY = 'ag-tracking-params';

function setTracking(sendDataDogCustomEvent: UseSendDataDogCustomResult) {
  const { search, origin, pathname } = window.location;

  let referrer = document.referrer || '';
  if (referrer.startsWith(origin)) {
    referrer = '';
  }

  const searchTags = ['utm_', 'gclid=', 'ttclid', 'fbshare', 'referralCode', 'sub2'];
  let hasTrackingParams = [];
  if (!search || !search?.length) {
    hasTrackingParams = [];
  } else {
    hasTrackingParams = searchTags.filter((i) => search?.includes(i));
  }

  if (hasTrackingParams.length > 0 || referrer) {
    try {
      if (search) {
        setLocalStorageItem(AG_TRACKING_KEY, search);
      } else {
        removeLocalStorageItem(AG_TRACKING_KEY);
      }

      if (referrer) {
        setLocalStorageItem(AG_REFERRER_KEY, referrer);
      } else {
        removeLocalStorageItem(AG_REFERRER_KEY);
      }
    } catch (e) {
      sendDataDogCustomEvent({
        eventType: AG_TRACKING_PARAMS_KEY,
        success: false,
        data: {
          pathname
        },
        error: e as Error
      });
    }
  }
}

export function useAgTrackingStorage() {
  const sendDataDogCustomEvent = useSendDataDogCustomEvent();

  useEffect(() => {
    if (typeof window !== 'undefined' && window.localStorage) {
      setTracking(sendDataDogCustomEvent);
    }
  }, [sendDataDogCustomEvent]);
}
